/// <reference lib="ESNEXT" />
/// <reference lib="webworker" />

const AppWorker = new Worker(/* webpackChunkName: "app-worker" */ new URL('./app.worker.ts', import.meta.url), {
  type: 'module',
  name: 'app-worker',
});

export default AppWorker;
